var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"type":"textarea","rows":3},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})}
var staticRenderFns = []

export { render, staticRenderFns }